import React from "react";
import { Calendar } from "lucide-react";

/** Small presentational helpers shared across panels */

export const StatPill = ({ color, textColor, label, value }) => (
  <div style={{ padding: 12, backgroundColor: color, borderRadius: 8, textAlign: "center" }}>
    <div style={{ fontSize: 20, fontWeight: 600, color: textColor }}>{value}</div>
    <div style={{ fontSize: 12, color: textColor }}>{label}</div>
  </div>
);

export const EmptyState = ({ title, subtitle }) => (
  <div style={{ textAlign: "center", padding: "48px 24px" }}>
    <div
      style={{
        background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
        borderRadius: 20,
        padding: 24,
        display: "inline-block",
        marginBottom: 16,
      }}
    >
      <Calendar style={{ width: 48, height: 48, color: "#3b82f6" }} />
    </div>
    <h3 style={{ fontSize: 18, fontWeight: 600, color: "#111827", marginBottom: 8 }}>{title}</h3>
    <p style={{ color: "#6b7280", margin: 0 }}>{subtitle}</p>
  </div>
);

export const SectionCard = ({ children, variant = "card", ...props }) => (
  <section className={`dui-card ${variant === "flat" ? "dui-card--flat" : ""}`} {...props}>
    {children}
    <style>{`
      .dui-card {
        background:#fff;
        border:1px solid #e5e7eb;
        border-radius:16px;
        box-shadow:0 10px 18px -16px rgba(0,0,0,.2);
      }
      .dui-card--flat {
        background:transparent;
        border:0;
        border-radius:0;
        box-shadow:none;
      }
    `}</style>
  </section>
);

export const SectionHeader = ({ icon, title, right, variant = "card" }) => (
  <header className={`dui-head ${variant === "flat" ? "dui-head--flat" : ""}`}>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      {icon}
      <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#111827" }}>{title}</h3>
    </div>
    {right}
    <style>{`
      .dui-head {
        padding:14px 16px;
        border-bottom:1px solid #e5e7eb;
        background:#f8fafc;
        border-top-left-radius:16px;
        border-top-right-radius:16px;
      }
      .dui-head--flat {
        background:transparent;
        border:0;
        padding:8px 0 12px;
      }
    `}</style>
  </header>
);

export const LabeledInput = ({ label, ...rest }) => (
  <div style={{ marginBottom: 20 }}>
    <label
      style={{
        display: "block",
        fontSize: 14,
        fontWeight: 500,
        color: "#374151",
        marginBottom: 8,
      }}
    >
      {label}
    </label>
    <input
      {...rest}
      style={{
        width: "100%",
        padding: 16,
        border: "1px solid #d1d5db",
        borderRadius: 12,
        fontSize: 14,
        transition: "all 0.2s",
        backgroundColor: "#f9fafb",
        boxSizing: "border-box",
      }}
      className="focus-ring"
    />
  </div>
);

export const LabeledTextarea = ({ label, rows = 3, ...rest }) => (
  <div style={{ marginBottom: 20 }}>
    <label
      style={{
        display: "block",
        fontSize: 14,
        fontWeight: 500,
        color: "#374151",
        marginBottom: 8,
      }}
    >
      {label}
    </label>
    <textarea
      rows={rows}
      {...rest}
      style={{
        width: "100%",
        padding: 16,
        border: "1px solid #d1d5db",
        borderRadius: 12,
        fontSize: 14,
        transition: "all 0.2s",
        backgroundColor: "#f9fafb",
        resize: "none",
        boxSizing: "border-box",
      }}
      className="focus-ring"
    />
  </div>
);
